import { AxiosInstance } from "axios"
import { ReportDetails, ReportSummary, PosSale, ConferenceDetails } from "./conferenceTypes"
import { Period } from "../../../dashboards/dashboardTypes"

export enum ConferenceMerchantQuery {
    TODAYS_POS_SALES = "todays-POS-sales-enum",
    CONFERENCE_VIEW = "conference-view-for-merchant",
}

type TodaysPosSalesWithEnumParams = Readonly<{
    merchantId: number
    period: Period
}>

export type TodaysPosSalesWithEnumResponse = Readonly<{
    reportDetails: ReportDetails
    posSales: PosSale[]
    reportSummary: ReportSummary
}>

export async function fetchTodaysPosSalesWithEnum(
    { merchantId, period }: TodaysPosSalesWithEnumParams,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<TodaysPosSalesWithEnumResponse> {
    const url = `/merchants/${merchantId}/dashboard/posSale`

    const response = await axios.get(url, {
        params: {
            period,
        },
        signal,
    })

    return response.data
}

type ConferenceViewParams = Readonly<{
    merchantId: number
}>

export type ConferenceViewResponse = Readonly<{
    conferenceDetails: ConferenceDetails
}>

export async function fetchConferenceView(
    { merchantId }: ConferenceViewParams,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<ConferenceViewResponse> {
    const url = `/merchants/${merchantId}/dashboard/views/conference`

    const response = await axios.get(url, {
        params: {},
        signal,
    })

    return response.data
}
